import { configAdapter } from '../../../adapters';
import { configDomain, configEndpoint } from '../../../constants';
import { parkingSplitApi } from '../apiBase';
export var configRegion = '4';
export var configApi = parkingSplitApi.injectEndpoints({
    overrideExisting: true,
    endpoints: function (builder) { return ({
        getConfig: builder.query({
            query: function () { return ({
                url: "".concat(configDomain).concat(configRegion).concat(configEndpoint),
                method: 'GET',
            }); },
            transformResponse: function (response) {
                return configAdapter(response);
            },
        }),
    }); },
});
export var useGetConfigQuery = configApi.useGetConfigQuery;
